export const computeProgressPercent = (
  quantity: number,
  shipQuantity: number,
) => {
  if (shipQuantity <= 0) {
    return 0;
  }
  const percent = (quantity / shipQuantity) * 100;
  return Math.min(100, Math.max(0, percent));
};
